import { BlobProvider } from "@react-pdf/renderer";
import { useCallback, useEffect, useState } from "react";
import { IssueReportPdf } from "./IssueReportPdf";
import API from "services/axios";
import authHeader from "services/auth-header";
import { setNotification } from "features/Notification/notificationSlice";
import { useDispatch } from "react-redux";
import Spinner from "components/Spinner";

function IssueReportPdfButton({ startDate, endDate, sortBy, sortDirection }) {
  /*   All States
   ********************************************* */
  const [showPdf, setShowPdf] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  /*   All Functions
   ********************************************* */
  const getPurchaseReport = useCallback(async () => {
    try {
      setLoading(true);

      // increment 1 to endDate
      const endDateObj = new Date(endDate);

      // get only date frm endDateObj not time
      const endDateString = endDateObj.toISOString().slice(0, 10);

      const { data } = await API.post(
        "/manufacturer-issues-report-for-pdf",
        {
          startDate: startDate,
          endDate: endDateString,
          sortBy: sortBy,
          sortDirection: sortDirection,
        },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setReportData(data?.data);
        setShowPdf(true);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, sortBy, sortDirection]);

  /*   All UseEffects
   ********************************************* */
  // Reset showPdf when reportData changes to regenerate the PDF

  return (
    <div className="relative">
      {loading && <Spinner />}
      {showPdf ? (
        <BlobProvider document={<IssueReportPdf reportData={reportData} />}>
          {({ url, blob }) => {
            const isDisabled = !blob;
            return (
              <>
                <a
                  href={isDisabled ? "#" : url}
                  download={`Issue-Report-${startDate || ""}-${endDate || ""}.pdf`}
                  className="text-decoration-none text-white btn btn-success btn"
                  onClick={(e) => {
                    if (isDisabled) e.preventDefault();
                  }}
                >
                  <i className="mdi mdi-download"></i>Download Report
                </a>
                <a
                  href={isDisabled ? "#" : url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-white btn btn-primary btn ms-1"
                  onClick={(e) => {
                    if (isDisabled) e.preventDefault();
                  }}
                >
                  <i className="mdi mdi-eye"></i>View Report
                  {!url && (
                    <div
                      className="spinner-border spinner-border-sm text-white mb-1"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </a>
              </>
            );
          }}
        </BlobProvider>
      ) : (
        <button className="btn btn-primary btn " onClick={getPurchaseReport}>
          <i className="mdi mdi-file-pdf"></i> Generate Report
        </button>
      )}
    </div>
  );
}

export default IssueReportPdfButton;
